import { render, staticRenderFns } from "./PreviousNameMethod.vue?vue&type=template&id=1f9ec47b"
import script from "./PreviousNameMethod.vue?vue&type=script&lang=js"
export * from "./PreviousNameMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports